import React from "react";

// Tileable "M" monogram pattern, rendered at low opacity as a background texture.
export const MPattern = ({ className = "", color = "#3C8DD0", opacity = 0.05 }) => (
  <div className={`pointer-events-none absolute inset-0 ${className}`} style={{ opacity }} aria-hidden="true">
    <svg width="100%" height="100%">
      <defs>
        <pattern id="mpat" width="80" height="80" patternUnits="userSpaceOnUse" patternTransform="rotate(0)">
          <path
            d="M18 58V26l12 16 12-16v32"
            fill="none"
            stroke={color}
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#mpat)" />
    </svg>
  </div>
);
